import React from 'react';
import { Grid, Tooltip } from '@material-ui/core';
import {
  StyledCaptions,
  ItemWrapper,
  ContentWrapper,
  StyledIcon,
  StyledSmallIcon,
} from 'components/MenuItem/styles';
import { AssuranceIcon } from 'images';
import { IntlShape, injectIntl } from 'react-intl';
import { darkBlue } from 'Material-UI/colors';
import { pushTo } from 'helpers/routes';
import { connect, useSelector } from 'react-redux';
import {
  getContractsAMC,
  getIsOpenAddNewContractModalSelector,
} from 'store/contract/selectors';

import { createStructuredSelector } from 'reselect';
import AddNewContractModal from 'components/AddNewContractModal';
import ModalServicesAuto from 'components/ModalServices/ModalServicesAuto';
import {
  getIsModalCreateFolder,
  getIsModalServicesAutoSelector,
  getIsModalServicesMrhSelector,
} from 'store/global/selectors';
import ModalServicesMrh from 'components/ModalServices/ModalServicesMrh';
import ModalDeclareFolder from 'components/ModalDeclareFolder';
import GaClickHOC from 'helpers/GATracking/GaClickHOC';
import { DeclareFolderProcess } from 'containers/AMCDashboard/DeclareFolderProcess';
import { StoreContext } from 'utils/contextStore';
import { getOrganismesApi } from 'store/user/apis';

type MenuItemType = {
  items: any;
  setDetailsPageBreadcrumbsPath: Function;
  intl: IntlShape;
  openServices: Function;
  isOpen: boolean;
  isOpenModalService: boolean;
  isOpenModalServiceMrh: boolean;
  isOpenModalCreateFolder?: boolean;
  closeModalCreateFolder?: Function;
};
const MenuItem = ({
  isOpen,
  isOpenModalService,
  isOpenModalServiceMrh,
  isOpenModalCreateFolder,
  closeModalCreateFolder,
  ...props
}: MenuItemType) => {
  const { organismeListState } = React.useContext(StoreContext);
  const setOrganismeList = organismeListState?.setOrganismeList;
  const getContracts = useSelector(getContractsAMC);

  React.useEffect(() => {
    getOrganismesApi()
      .then((result) => {
        const dmoOrganisme: any[] = [];
        if (result.data.data.length > 0) {
          /* istanbul ignore next */
          getContracts.map(
            /* istanbul ignore next */ (c: any) => {
              const organisme = result.data.data.find(
                /* istanbul ignore next */ (r: any) =>
                  r.NUM_POLICE === c.NUM_POLICE,
              );
              organisme && dmoOrganisme.push(organisme);
              return null;
            },
          );
        }
        /* istanbul ignore next */
        setOrganismeList(dmoOrganisme);
      })
      .catch((error) => {});
  }, [getContracts]);

  return (
    <>
      <Grid spacing={3} container>
        {props.items.map(
          (
            item: {
              path?: string;
              onPress?: Function;
              icon: string;
              title: string;
              BreadcrumbsPath?: { name: string; path: string }[];
              openModalServices?: Boolean;
              smalIcon?: Boolean;
              category: string;
              label: string;
              openModalOrganisme?: Boolean;
              isNew?: Boolean;
              hasToolTip?: Boolean;
              toolTipText?: string;
            },
            index: number,
          ) => (
            <Grid item xs={4} key={index}>
              {item.hasToolTip ? (
                <GaClickHOC category={item.category} label={item.label}>
                  <Tooltip
                    title={props.intl.formatMessage({
                      id: item.toolTipText,
                    })}
                  >
                    <ItemWrapper
                      style={
                        item.isNew && {
                          borderWidth: 4,
                          borderColor: '#F9AA01',
                          borderStyle: 'solid',
                          borderRadius: '5px',
                        }
                      }
                      data-testid="menu_item"
                      onClick={
                        /* istanbul ignore next */ () => {
                          if (item.BreadcrumbsPath) {
                            props.setDetailsPageBreadcrumbsPath(
                              item.BreadcrumbsPath,
                            );
                            item.path && pushTo(item.path);
                          } else if (item.openModalServices) {
                            props.openServices();
                          } else if (item.onPress) {
                            item.onPress();
                          } else {
                            item.path && pushTo(item.path);
                          }
                        }
                      }
                    >
                      {item.isNew && (
                        <span
                          style={{
                            fontSize: 10,
                            position: 'absolute',
                            color: 'white',
                            fontFamily: 'Roboto',
                            paddingRight: 8,
                            paddingLeft: 8,
                            backgroundColor: '#F9AA01',
                            boxSizing: 'border-box',
                          }}
                        >
                          {props.intl.formatMessage({ id: 'menu.item.new' })}
                        </span>
                      )}

                      <ContentWrapper>
                        {item.smalIcon ? (
                          <StyledSmallIcon src={AssuranceIcon[item.icon]} />
                        ) : (
                          <StyledIcon src={AssuranceIcon[item.icon]} />
                        )}
                        <StyledCaptions weight="500" color={darkBlue}>
                          {item.title}
                        </StyledCaptions>
                      </ContentWrapper>
                    </ItemWrapper>
                  </Tooltip>
                </GaClickHOC>
              ) : (
                <GaClickHOC category={item.category} label={item.label}>
                  <ItemWrapper
                    style={
                      item.isNew && {
                        borderWidth: 4,
                        borderColor: '#F9AA01',
                        borderStyle: 'solid',
                        borderRadius: '5px',
                      }
                    }
                    data-testid="menu_item"
                    onClick={() => {
                      if (item.BreadcrumbsPath) {
                        props.setDetailsPageBreadcrumbsPath(
                          item.BreadcrumbsPath,
                        );
                        item.path && pushTo(item.path);
                      } else if (item.openModalServices) {
                        props.openServices();
                      } else if (item.onPress) {
                        item.onPress();
                      } else {
                        item.path && pushTo(item.path);
                      }
                    }}
                  >
                    {item.isNew && (
                      <span
                        style={{
                          fontSize: 10,
                          position: 'absolute',
                          color: 'white',
                          fontFamily: 'Roboto',
                          paddingRight: 8,
                          paddingLeft: 8,
                          backgroundColor: '#F9AA01',
                          boxSizing: 'border-box',
                          marginRight: '20px',
                          borderBottomLeftRadius: '5px',
                        }}
                      >
                        {props.intl.formatMessage({ id: 'menu.item.new' })}
                      </span>
                    )}

                    <ContentWrapper>
                      {item.smalIcon ? (
                        <StyledSmallIcon src={AssuranceIcon[item.icon]} />
                      ) : (
                        <StyledIcon src={AssuranceIcon[item.icon]} />
                      )}
                      <StyledCaptions weight="500" color={darkBlue}>
                        {item.title}
                      </StyledCaptions>
                    </ContentWrapper>
                  </ItemWrapper>
                </GaClickHOC>
              )}
            </Grid>
          ),
        )}
        <AddNewContractModal isOpen={isOpen} />
        <ModalDeclareFolder
          closeModalCreateFolder={closeModalCreateFolder}
          isOpen={isOpenModalCreateFolder}
          content={<DeclareFolderProcess />}
        />
        <ModalServicesAuto isOpen={isOpenModalService} />
        <ModalServicesMrh isOpen={isOpenModalServiceMrh} />
      </Grid>
    </>
  );
};

const mapStateToProps = createStructuredSelector<
  any,
  {
    isOpen: boolean;
    isOpenModalService: boolean;
    isOpenModalServiceMrh: boolean;
    isOpenModalCreateFolder: boolean;
  }
>({
  isOpen: getIsOpenAddNewContractModalSelector,
  isOpenModalService: getIsModalServicesAutoSelector,
  isOpenModalServiceMrh: getIsModalServicesMrhSelector,
  isOpenModalCreateFolder: getIsModalCreateFolder,
});

export default connect(mapStateToProps)(injectIntl(MenuItem));
export { MenuItem };
